import React from 'react';

const Video = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="38.011" height="38.011" viewBox="0 0 38.011 38.011"><g transform="translate(-307.716 -395.277)"><path d="M38.011,30.644V0H0V30.644H14.107l-1.9,5.14H7.944v2.227H30.067V35.783h-4.26l-1.9-5.14ZM35.784,2.227V23.962H2.227V2.227ZM2.227,26.189H35.784v2.227H2.227Zm21.2,9.594H14.579l1.9-5.14h5.046Z" transform="translate(307.716 395.277)" fill="#4d4332"/><path d="M211,47.972v13.07l9.8-6.535Zm2.227,4.162,3.56,2.374-3.56,2.374Z" transform="translate(112.381 354.957)" fill="#4d4332"/></g></svg>
    );
}

export default Video;
